export default {
  img_cropper: {
    upload_img: '上传图片',
    reset: '重置',
    amplification: '放大',
    narrow: '缩小'
  }
}
